import "./ContentArea.scss";
import { ContentAreaType } from "/Models/Generated/ContentAreaType";
import { ContentAreaProps } from "/Models/Generated/ContentAreaProps";
import { ComponentWrapperProps } from "/Models/Generated/ComponentWrapperProps";
import { RichTextExtensionProps } from "/Components/Shared/RichText/RichText";
import ContentAreaItem, {
  ContentAreaItemMargin,
} from "../ContentAreaItem/ContentAreaItem";
import { createSpreadableBem } from "/Helpers/createBem";

export interface ContentAreaOrRichText extends ContentAreaProps {
  richText?: RichTextExtensionProps;
  margin?: ContentAreaItemMargin;
}

export const HasContent = (
  contentAreaProps: ContentAreaProps | undefined,
): boolean => (contentAreaProps?.items?.length ?? 0) > 0;

const ContentArea = (props: ContentAreaOrRichText) => {
  const { propertyName, contentAreaType, items, margin } = props;
  const isRichText = contentAreaType === ContentAreaType.RichText;
  const useBlockOPE = !isRichText && !!propertyName;

  if (!HasContent(props) && !propertyName) {
    return null;
  }

  const bem = createSpreadableBem("content-area-react");
  return (
    <div
      {...bem("", {
        "__edit-placeholder": propertyName,
        "__edit-mode": propertyName,
        "!epi-editContainer": isRichText && !!propertyName,
      })}
      data-epi-property-name={propertyName}
      data-epi-property-render={useBlockOPE && propertyName ? "client" : null}
      data-epi-edit={isRichText ? propertyName : null}
    >
      {items &&
        items.map((item: ComponentWrapperProps, idx) => (
          <ContentAreaItem
            key={idx + item.name}
            {...{
              idx,
              item,
              useBlockOPE,
              richText: props.richText,
              contentAreaType,
              margin: margin,
            }}
          />
        ))}
    </div>
  );
};

ContentArea.ItemMargin = ContentAreaItem.Margin;
ContentArea.HasContent = HasContent;

export default ContentArea;
